var _defs, _path, _rect, _rect2, _rect3, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle2, _path14, _path15, _rect4, _path16, _rect5, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSchluesseltresore = function SvgSchluesseltresore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.132,
    height: 79.814
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "schluesseltresore_svg__a",
    x1: 6.453,
    x2: 61.679,
    y1: 43.45,
    y2: 43.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M15.215 73.169H5.562v6.645h7.111zM52.917 73.169h9.653v6.645h-7.111z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73.267,
    height: 68.132,
    x: -2.567,
    y: 2.567,
    fill: "#bcc8cc",
    rx: 6,
    transform: "rotate(90 34.066 36.633)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 57.008,
    height: 62.144,
    x: 5.562,
    y: 5.562,
    fill: "#4c6f73",
    rx: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 60.361,
    height: 55.226,
    x: 3.885,
    y: 9.02,
    fill: "#a0b2b6",
    rx: 3,
    transform: "rotate(90 34.066 36.633)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.123,
    cy: 36.639,
    r: 11.605,
    fill: "#bcc8cc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#schluesseltresore_svg__a)",
    d: "M6.453 30.874v17.704c21.73-7.868 40.939-1.535 55.226 7.448V34.604c-15.86.121-38.744-1.955-55.226-3.73",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "M38.977 19.41a1.477 1.477 0 0 0-1.787 1.14L33.8 32.648l1.566.568 4.846-13.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "M42.088 22.326a1.477 1.477 0 0 0-.641-2.02l-1.235-.448-4.846 13.36 1.567.567Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M40.212 19.858a1.4 1.4 0 0 0-1.821.927l-3.535 12.247 1.02.37 5.14-11.665a1.4 1.4 0 0 0-.804-1.88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "M16.842 31.722a1.477 1.477 0 0 0 1.14 1.788l12.1 3.39.567-1.567-13.36-4.846Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "M19.758 28.611a1.477 1.477 0 0 0-2.02.642l-.448 1.234 13.36 4.846.568-1.566Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M17.29 30.487a1.4 1.4 0 0 0 .927 1.822l12.247 3.535.37-1.021-11.665-5.14a1.4 1.4 0 0 0-1.88.804"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "M29.154 53.857a1.477 1.477 0 0 0 1.788-1.14l3.39-12.099-1.567-.568-4.845 13.36Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "M26.043 50.941a1.477 1.477 0 0 0 .642 2.02l1.235.449 4.845-13.36-1.566-.568Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M27.92 53.41a1.4 1.4 0 0 0 1.821-.928l3.535-12.247-1.021-.37-5.139 11.665a1.4 1.4 0 0 0 .804 1.88"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "M51.29 41.545a1.477 1.477 0 0 0-1.14-1.787l-12.1-3.39-.568 1.566 13.36 4.846Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "M48.373 44.656a1.477 1.477 0 0 0 2.021-.641l.448-1.235-13.36-4.846-.568 1.567Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M50.842 42.78a1.4 1.4 0 0 0-.928-1.822l-12.247-3.534-.37 1.02 11.665 5.14a1.4 1.4 0 0 0 1.88-.804"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.123,
    cy: 36.639,
    r: 5.249,
    fill: "#4c6f73"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#093a3e",
    d: "M34.123 40.299a3.66 3.66 0 1 1 3.66-3.66 3.664 3.664 0 0 1-3.66 3.66"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M62.528 26.43v-8.062a.794.794 0 0 1 .794-.794h-1.391a.794.794 0 0 0-.795.794v8.061a.794.794 0 0 0 .795.795h1.391a.794.794 0 0 1-.794-.795"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.84,
    height: 9.65,
    x: 62.528,
    y: 17.574,
    fill: "#a0b2b6",
    rx: 0.794
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M62.528 54.98v-8.061a.794.794 0 0 1 .794-.795h-1.391a.794.794 0 0 0-.795.795v8.06a.794.794 0 0 0 .795.795h1.391a.794.794 0 0 1-.794-.794"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.84,
    height: 9.65,
    x: 62.528,
    y: 46.124,
    fill: "#a0b2b6",
    rx: 0.794
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "m6.453 56.54-.109-11.926-.039-11.925-.057-23.873a2.9 2.9 0 0 1 1.896-2.401 4.1 4.1 0 0 1 1.544-.171l1.49.004 5.963.02 11.926.037 11.925.039 11.925.109-11.925.109-11.925.039-11.926.038-5.962.018-1.49.005a3.7 3.7 0 0 0-1.399.155 2.47 2.47 0 0 0-1.6 2.046L6.6 32.69l-.039 11.925Z"
  }))));
};
export default SvgSchluesseltresore;